import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import type { AppDispatch, RootState } from "../../app/store";
import { hydrateSessionData, startNewSession, setAccessCode, setUserId, setPostSurveyTime } from "./sessionDataSlice";
import { sendEvent, sendUserLoginEvent, sessionStartEventBuilder } from "../../utils/event-helpers";
import { SESSION_DATA_LS_KEY } from "./initializeSessionData";

export const sessionListenerMiddleware = createListenerMiddleware();

const startAppListening = sessionListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startAppListening({
    matcher: isAnyOf(hydrateSessionData, startNewSession, setAccessCode, setUserId, setPostSurveyTime),
    effect: async (_action, listenerApi) => {
        const state = listenerApi.getState() as RootState;
        localStorage.setItem(SESSION_DATA_LS_KEY, JSON.stringify(state.session));
    },
});

startAppListening({
    actionCreator: setUserId,
    effect: (_action, listenerApi) => {
        const state = listenerApi.getState() as RootState;
        const { userId } = state.session;

        if (!userId) return;
        sendUserLoginEvent(userId);
    },
});

startAppListening({
    actionCreator: startNewSession,
    effect: (_action, listenerApi) => {
        const state = listenerApi.getState() as RootState;
        const { userId, sessionId } = state.session;

        if (!userId || !sessionId) return;
        sendEvent(sessionStartEventBuilder(userId, sessionId));
    },
});
